var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCentral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#5C5F62",
  clipPath: "url(#central_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.533 3.23v17.905a.832.832 0 0 0 1.664 0V3.23a.832.832 0 0 0-1.664 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.532 13.267h4.566a.9.9 0 1 0 0-1.8h-4.566v-2.7l-3.591 3.6 3.59 3.6zM5.464 11.467H.898a.9.9 0 1 0 0 1.8h4.566v2.7l3.591-3.6-3.59-3.6z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "central_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgCentral;